// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2D_Eo","legacyBtn":"MutateMid_legacyBtn__1jL4F"};